// Uses Unicode property escapes to allow letters from any language (Arabic, Chinese, Japanese, etc.)
// \p{L} matches letters, \p{M} matches combining marks (needed for Thai, Vietnamese, etc.)
const VALID_NAME_PATTERN = /^[\p{L}\p{M}0-9\s_\-()[\]&]+$/u

export const validateCollectionName = name => {
  if (!name || !name.trim()) {
    return "Can't be blank"
  }

  if (name.toLowerCase() === 'users') {
    return '"Users" is a reserved name'
  }

  if (!VALID_NAME_PATTERN.test(name)) {
    return 'Collection names can only contain letters, numbers, spaces, underscores, hyphens, parentheses, brackets, and ampersands'
  }

  return undefined
}

export const validate = values => {
  const errors = {}

  errors.name = validateCollectionName(values.name)

  return errors
}
